import createIcon from '@/lib/create-icon'

const AnalyzeChartIcon = createIcon(
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 18 18' fill='none'>
    <path
      d='M12.375 7.08911L9.96734 9.52567C9.652 9.8448 9.12889 9.81753 8.84844 9.46734L8.54853 9.09284C8.2692 8.74404 7.74876 8.71535 7.43278 9.03133L5.625 10.8391M12.375 7.08911H10.6875M12.375 7.08911V8.69625M5.25 15.75H12.75C14.4069 15.75 15.75 14.4069 15.75 12.75V5.25C15.75 3.59315 14.4069 2.25 12.75 2.25H5.25C3.59315 2.25 2.25 3.59315 2.25 5.25V12.75C2.25 14.4069 3.59315 15.75 5.25 15.75Z'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
      fill='none'
    />
  </svg>,
  'AnalyzeChartIcon'
)

export default AnalyzeChartIcon
